export default __webpack_public_path__ + "images/12_1_image.jpg";